import { INQPassword } from './../components/contentComponents.jsx';


function Inquiryboard() {
  return (
    <div id="page-top">
      <div class="container inqdashboardpadd">
        <INQPassword />
      </div>
    </div>
  );
}

export default Inquiryboard;
